// Packages Import
import React, { Fragment, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
// Project Component
import useHttp from "../../../Hooks/use-http";
import FullScreenLoadingIndicator from "../../UI/FullScreenLoadingIndicator";
import { APIURL, PDF_GEN_URL, PDF_GEN_JWT_TOKEN_URL } from "../../Util/Util";
import SearchFilterArea from "./SearchFilterArea";
import Code4ReportTable from "./Code4ReportTable";
import Code4ReportInfo from "./Code4ReportInfo";
import { Code4ReportAction } from "../../../store/Code4Report/Code4Report-slice";
import ErrorBox from "../../Util/ErrorBox";
import Code4PartsTable from "./Code4PartsTable";
import usePreventPageLoad from "../../Util/usePreventPageLoad";
import ControlledMessageBox from "../../Util/ControlledMessagebox";

let errorMsg = "";

const Code4Report = () => {
	const dispatch = useDispatch();
	const accessToken = useSelector((state) => state.authenticationState.accessToken);
	const userNTID = useSelector((state) => state.authenticationState.userNTID);

	const headers = { "Content-Type": "application/json", Authorization: "Bearer " + accessToken };
	// const headers = { "Content-Type": "application/json"};
	const { isLoading, sendRequest: fetchData } = useHttp();
	const { isLoading: isLoading2, sendRequest: fetchData2 } = useHttp();
	const { isLoading: isLoading3, sendRequest: fetchData3 } = useHttp();
	const { isLoading: isLoading4, sendRequest: fetchData4 } = useHttp();
	const { sendRequest: fetchDataWithoutLoad } = useHttp();
	const [toggleErrorPopUp, setToggleErrorPopUp] = useState(false);
	const filteredData = useSelector((state) => state.code4ReportState.filteredData);
	const prevFilteredData = useSelector((state) => state.code4ReportState.prevFilteredData);
	const projectTableData = useSelector((state) => state.code4ReportState.PROJECT_INFO_TABLE);
	const code4PartsEditStates = useSelector((state) => state.code4ReportState.code4PartsEditStates);

	const fetched_bom_ppn = useSelector((state) => state.code4ReportState.fetched_bom_ppn);

	const [errorMessage, setErrorMsg] = useState("");
	const [errorState, setErrorState] = useState(false);
	const [controlledMessage, setControlledMessage] = useState("");
	const [openControlMessageBox, setOpencontrolMessageBox] = useState(false);

	const unblockRef = usePreventPageLoad(code4PartsEditStates.editing);
	const unblockRefFromEmail = usePreventPageLoad(filteredData.from_email);

	const userInfo = {
		username: useSelector((state) => state.authenticationState.userNTID),
		org: useSelector((state) => state.authenticationState.User_Assigned_Orgs),
		name: useSelector((state) => state.authenticationState.userName),
	};
	const updateData = (data, isInitialPageLoad = false) => {
		dispatch(Code4ReportAction.updateAll({ data: data }));
		unblockRef.current();
		dispatch(Code4ReportAction.clearEditedTable());
		if (!isInitialPageLoad) {
			dispatch(Code4ReportAction.setCode4PartsTableInfo([]));
			dispatch(Code4ReportAction.setEditingTable(false));
		}
	};

	const updateProjectsList = (data, area) => {
		dispatch(Code4ReportAction.updateProjectsList({ data: data, area: area }));
	};

	const getProjectsList = (org, area) => {
		fetchDataWithoutLoad(
			{
				url: `${APIURL}Projects/projectslist/${org}`,
				headers: headers,
			},
			(data) => {
				updateProjectsList(data, area);
			}
		);
	};

	const updateOrg = (data) => {
		dispatch(Code4ReportAction.updateOrg({ data: data, userOrg: userInfo.org.primaryOrg }));
	};
	const handleProjectInfoCancel = () => {
		fetchData3(
			{
				url: `${APIURL}Projects/projectsDetails`,
				headers: headers,
				method: "POST",
				body: prevFilteredData,
			},
			updateData
		);
	};
	const handleSearchFilterData = (isInitialPageLoad) => {
		dispatch(Code4ReportAction.savePrevFilterData({ data: filteredData }));
		fetchData3(
			{
				url: `${APIURL}Projects/projectsDetails`,
				headers: headers,
				method: "POST",
				body: filteredData,
			},
			(data) => {
				updateData(data, isInitialPageLoad);
				if (isInitialPageLoad) {
					dispatch(Code4ReportAction.setShouldAutoSelectCheckBox(true));
				}
			}
		);
		getProjectsList(filteredData.userOrg, "info");
	};

	const handleJWTToken = (token, isLoading) => {
		const projectDetailsMapped = projectTableData.map((rowData) => {
			const retItem = {
				bomno: rowData.bom,
				rev: rowData.rev,
				liaison: rowData.liaison,
				project: rowData.project,
				bomcount: rowData.bomPartsNum,
				dlastadd: rowData.bomDateLoad,
				dduedate: rowData.rptDeliveryDueDate,
				dcompl: rowData.dateCompleted,
			};

			return retItem;
		});
		const data = {
			client_id: "mlar",
			template: "projects",
			paper_size: "a4",
			prepared_by: userInfo.name,
			start_date: filteredData.startDate,
			end_date: filteredData.endDate,
			projects_details: projectDetailsMapped,
			userorg: prevFilteredData.userOrg,
		};
		let filename = "";
		fetch(PDF_GEN_URL, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token.access}`,
			},
			body: JSON.stringify(data),
		})
			.then((response) => {
				const disposition = response.headers.get("content-disposition");
				filename = disposition.match(/filename=(.+)/)[1];
				return response.blob();
			})
			.then((data) => {
				const url = window.URL.createObjectURL(data);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", filename);
				document.body.appendChild(link);
				link.click();
				link.remove();
				isLoading(false);
			})
			.catch((error) => {
				errorMsg = error.toString();
				setToggleErrorPopUp(true);
				isLoading(false);
			});
	};

	const fileDownloadPdf = (setLoading) => {
		fetchDataWithoutLoad(
			{
				url: PDF_GEN_JWT_TOKEN_URL,
				headers: headers,
				method: "POST",
				body: {
					username: "admin",
					password: "pass",
				},
			},
			(data) => handleJWTToken(data, setLoading)
		);
	};

	const fetchCode4Parts = (bom_ppn) => {
		const body = {
			userid: userNTID,
			userorg: "F01",
			bom_ppn: bom_ppn, // Either single string or array
			bom_prev: null,
		};
		fetchData2(
			{
				url: `${APIURL}code4Report/bomFilterCode4Parts`,
				headers: headers,
				method: "POST",
				body: body,
			},
			(data) => {
				console.log(data);
				dispatch(Code4ReportAction.setCode4PartsTableInfo(data.FILTER_RECORDS.map((val, i) => ({ ...val, id: i }))));
			},
			(error) => {
				setErrorState(true);
				setErrorMsg(`ERROR: ${error}`);
			}
		);
	};

	const updateCode4Parts = async (body) => {
		await fetchData4(
			{
				url: `${APIURL}code4Report/updateCode4Parts`,
				headers: headers,
				method: "POST",
				body: body,
			},
			(data) => {
				console.log(data);
				setOpencontrolMessageBox(true);
				setControlledMessage(data.Success);
				dispatch(Code4ReportAction.clearEditedTable());
				dispatch(Code4ReportAction.setEditingTable(false));
				fetchCode4Parts(fetched_bom_ppn);
				setTimeout(() => {
					setOpencontrolMessageBox(false);
					setControlledMessage("");
				}, 2000);
			},
			(error) => {
				setErrorState(true);
				setErrorMsg(`ERROR: ${error}`);
			}
		);
	};

	const handleExport = () => {
		let filename = "";
		const body = {
			userid: userNTID,
			userorg: userInfo.org.primaryOrg,
			// "bom_ppn": "ET57755-2001",
			bom_ppn: fetched_bom_ppn,
			bom_prev: null,
		};
		dispatch(Code4ReportAction.setExcelIsLoading(true));
		fetch(`${APIURL}code4Report/generateCode4PartExcelReport`, {
			method: "POST",
			headers: headers,
			body: JSON.stringify(body),
		})
			.then((response) => {
				const disposition = response.headers.get("content-disposition");
				filename = disposition.match(/filename=(.+)/)[1];
				return response.blob();
			})
			.then((data) => {
				const url = window.URL.createObjectURL(data);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", filename);
				document.body.appendChild(link);
				link.click();
				link.remove();
				dispatch(Code4ReportAction.setExcelIsLoading(false));
			})
			.catch((error) => {
				console.log(error);
				errorMsg = error.toString();
				setToggleErrorPopUp(true);
				dispatch(Code4ReportAction.setExcelIsLoading(false));
			});
	};

	useEffect(() => {
		// getProjectsList(userInfo.org.primaryOrg , "all")
		fetchData(
			{
				url: `${APIURL}MtlEngInfo/userOrgsList`,
				headers: headers,
			},
			updateOrg
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<React.StrictMode>
			<Fragment>
				<FullScreenLoadingIndicator loading={isLoading || isLoading2 || isLoading3 || isLoading4} />
				<ControlledMessageBox open={openControlMessageBox} message={controlledMessage} />

				<ErrorBox msg={errorMessage} setErrorState={setErrorState} ErrorState={errorState} />
				<ErrorBox msg={errorMsg} setErrorState={setToggleErrorPopUp} ErrorState={toggleErrorPopUp} />
				<Box maxWidth={"85%"} mx={"auto"} mt={2}>
					<SearchFilterArea
						handleSearchFilterData={handleSearchFilterData}
						userInfo={userInfo}
						getProjectsList={getProjectsList}
						unblockRefFromEmail={unblockRefFromEmail}
						fetchCode4Parts={fetchCode4Parts}
					/>
					<Code4ReportTable />
					<Code4ReportInfo resetData={handleProjectInfoCancel} fileDownloadPdf={fileDownloadPdf} fetchCode4Parts={fetchCode4Parts} />
					<Code4PartsTable unblockRef={unblockRef} updateCode4Parts={updateCode4Parts} handleExport={handleExport} />
				</Box>
			</Fragment>
		</React.StrictMode>
	);
};

export default Code4Report;
